import { Component, OnInit } from "@angular/core";
import {
    FormControl,
    ReactiveFormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";

@Component({
    selector: "app-reset-password-langing-page",
    templateUrl: "./reset-password-langing-page.component.html",
    styleUrls: ["./reset-password-langing-page.component.scss"],
})
export class ResetPasswordLangingPageComponent implements OnInit {
    vendorInfo = new FormGroup({
        userName: new FormControl(null, Validators.required),
    });

    sellerName: any;
    responseData: any;
    isLoading: boolean = false;
    isError: boolean = false;
    isSuccess: boolean = false;
    isServerError: boolean = false;

    requestPasswordReset(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/payexap/api/forgottenPasswordReg",
            data
        );
    }

    constructor(
        private router: Router,
        private http: HttpClient,
        private authService: AuthService
    ) {}

    onResetReq() {
        this.isLoading = true;

        const user = {
            userName: this.vendorInfo.value.userName.replaceAll(/\s/g, ""),
            authorization: "anN3X2FwaV9hY2Nlc3M6RF5xM2Zza1otTk4lbkRmKw==",
        };
        //console.log(user);
        this.authService.forgotPassword(user).subscribe(
            (res) => {
                this.responseData = res;
                //console.log(this.responseData);
                this.isLoading = false;
                if (this.responseData.status == "success") {
                    //console.log('Success');
                    this.isSuccess = true;
                    this.isError = false;
                } else {
                    this.sellerName = this.vendorInfo.value.userName;
                    this.isError = true;
                    this.isSuccess = false;
                    //console.log(res);
                }
            },
            (error) => {
                this.isError = true;
            }
        );

        //console.log(user);
    }

    ngOnInit(): void {}
}
